import { ExternalRequest } from '../../../models/channel-communicator/external-request.model';
import { ExternalResponse } from '../../../models/channel-communicator/external-response.model';

/**
 * Definición de la clase BytteService, donde están los servicios para realizar el scaneo de imagenes
 *
 * *BytteService class definition, There are the services to scan images*
 *
 * @type {class}
 */
export class BytteService {
  /**
   * Variable que registra el origen de abre cuentas
   *
   * *Variable to save abre centas origin*
   *
   * @type {private}
   * @var {string} ABRE_CUENTAS_ORIGIN
   */
  private ABRE_CUENTAS_ORIGIN: string;

  /**
   * Declaración de función para promesas
   *
   * *Function promises declaration*
   *
   * @type {private}
   * @var {Function} createPromise
   */
  private createPromise: Function;

  /**
   * Declaración de función para mensaje al canal por solicitudes post
   *
   * *Function declaration for mesage to channle by post method*
   *
   * @type {private}
   * @var {Function} postMessageToChannel
   */
  private postMessageToChannel: Function;

  /**
   * Constructor de la clase
   * *Class Contstructor.*
   *
   * Inicializa los métodos para los modelos
   *
   * *Initialize method for models*
   *
   * @var {string} ABRE_CUENTAS_ORIGIN
   * @var {Function} createPromise
   * @var {Function} postMessageToChannel
   * @var {string} ABRE_CUENTAS_ORIGIN as ABRE_CUENTAS_ORIGIN
   * @var {function} createPromise as createPromise
   * @var {function} postMessageToChannel as postMessageToChannel
   */
  constructor(
    ABRE_CUENTAS_ORIGIN: string,
    createPromise: Function,
    postMessageToChannel: Function) {
    this.ABRE_CUENTAS_ORIGIN = ABRE_CUENTAS_ORIGIN;
    this.createPromise = createPromise;
    this.postMessageToChannel = postMessageToChannel;
  }

  /**
   * Función que registra la licencia de Bytte
   *
   * *Function that registers Bytte license*
   *
   * @type {Promise}
   * @param {string} licenseRegistrationUrl
   * @returns {Promise}
   */
  registerBytteLicense(licenseRegistrationUrl: string): Promise<ExternalResponse> {
    let promise: Promise<ExternalResponse>;

    const request: ExternalRequest = {
      origin: this.ABRE_CUENTAS_ORIGIN,
      op: 'registerDeviceLicense',
      syncMode: true,
      payload: {
        licenseRegistrationUrl,
      },
    };

    promise = this.createPromise(request.op);

    this.postMessageToChannel(request);
    return promise;
  }

  /**
   * Función que realiza la promesa para el scaneo de la parte posterior del documento
   *
   * *Function that creates de promise to back scan document*
   *
   * @type {Promise}
   * @param {string} licenseAndroid
   * @param {string} licenseIos
   * @param {string} password
   * @param {number} timeout
   * @returns {Promise}
   */
  backDocumentScan(licenseAndroid: string, licenseIos: string, password: string, timeout: number): Promise<ExternalResponse> {
    let promise: Promise<ExternalResponse>;

    const request: ExternalRequest = {
      origin: this.ABRE_CUENTAS_ORIGIN,
      op: 'backDocumentScan',
      syncMode: true,
      payload: {
        licenses: {
          android: licenseAndroid,
          ios: licenseIos,
        },
        password,
        timeout,
      },
    };

    promise = this.createPromise(request.op);

    this.postMessageToChannel(request);
    return promise;
  }

  /**
   * Función que realiza la promesa para el scaneo de la parte frontal del documento
   *
   * *Function that creates de promise to front scan document*
   *
   * @type {Promise}
   * @param {string} licenseAndroid
   * @param {string} licenseIos
   * @param {string} password
   * @param {number} timeout
   * @returns {Promise}
   */
  frontDocumentScan(licenseAndroid: string, licenseIos: string, password: string, timeout: number): Promise<ExternalResponse> {
    let promise: Promise<ExternalResponse>;

    const request: ExternalRequest = {
      origin: this.ABRE_CUENTAS_ORIGIN,
      op: 'frontDocumentScan',
      syncMode: true,
      payload: {
        licenses: {
          android: licenseAndroid,
          ios: licenseIos,
        },
        password,
        timeout,
      },
    };

    promise = this.createPromise(request.op);

    this.postMessageToChannel(request);
    return promise;
  }

  /**
   * Función que realiza la promesa para el scaneo de las huellas dáctilares
   *
   * *Function that creates de promise finger print scanning*
   *
   * @type {Promise}
   * @param {number} fingerPrintSigned
   * @param {string} password
   * @param {number} timeout
   * @returns {Promise}
   */
  fingerPrintsScan(fingerPrintSigned: string, password: string, timeout: number): Promise<ExternalResponse> {
    let promise: Promise<ExternalResponse>;

    const request: ExternalRequest = {
      origin: this.ABRE_CUENTAS_ORIGIN,
      op: 'fingerPrintsScan',
      syncMode: true,
      payload: {
        fingerPrintSigned,
        password,
        timeout,
      },
    };

    promise = this.createPromise(request.op);

    this.postMessageToChannel(request);
    return promise;
  }

  /**
   * Función que limpia los archivos residuales
   *
   * *Function that cleans residual files*
   *
   * @type {Promise}
   * @returns {Promise}
   */
  cleanResidualFiles(): Promise<any> {
    let promise: Promise<ExternalResponse>;

    const request: ExternalRequest = {
      origin: this.ABRE_CUENTAS_ORIGIN,
      op: 'deleteCaptureFiles',
      syncMode: false,
      payload: {},
    };

    promise = this.createPromise(request.op);

    this.postMessageToChannel(request);
    return promise;
  }
}
